enum DeviceHealthStatus {
    online = 'online',
    offline = 'offline',
    notSynced = 'notSynced',
    lowBattery = 'lowBattery',
}

export default DeviceHealthStatus;
